import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import HighmarkLogo from "../../../assets/images/highmark/ffb-logo.jpg";
import WinLogo from "../../../assets/images/win/logo-win.svg";
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Endpoints } from "../../../Global/Endpoints";
import axios from 'axios';

const Referral_Source = () => {

    const [selected, setSelected] = useState("");
    const [selectedReferralAmount, setSelectedReferralAmount] = useState("");
    const { t } = useTranslation();
    const navigate = useNavigate();

    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const {updatedProviderData,otherData} = location.state;
    debugger;
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const [serviceData, setServiceData] = useState([]);
    const handleBack = () => {
        navigate('/patientconsent-form', { state: { updatedFormData: updatedProviderData, otherData: {...otherData, referralSource: selected} } });
    };

    useEffect(() => {
        const getServiceAmount = async () => {
            try {
                setLoading(true);
                const params = {
                    EmailId: updatedProviderData?.EmailID,
                };
                const response = await axios.post(
                    Endpoints.UKDTCServiceAmounts,
                    null,
                    {
                    params: { _Params: JSON.stringify(params) },
                    }
                );
                setServiceData(response.data);
                if (response?.data.length > 0 && !otherData?.referralSource) {
                    setSelected(response.data[0].Serivce);
                    setSelectedReferralAmount(response.data[0].Amount);
                }
            } catch (err) {
                console.error('Error loading UKDTC service amounts:', err);
            } finally {
                setLoading(false);
            }
        };
        getServiceAmount();
    }, [])

    useEffect(() => {
        if (otherData && otherData.referralSource) {
            setSelected(otherData.referralSource);
        }
    }, [otherData]);
    
    const onNextClick = async () => {
        navigate('/services', { state: {updatedProviderData, otherData: {...otherData, referralSource: selected, referralSourceAmount: selectedReferralAmount }} });
    };

    if (loading) {
        return (
        <div className="loading-container">
            <div className="loading"></div>
            <h2 className="loading-text">{t("loading")}</h2>
        </div>
        );
    }

    return (
        <>
            <header>
                <nav className="navbar navbar-expand-lg container-fixed">
                    <a className="navbar-brand" href="#">
                        <img
                            src={isHighmarkPortal ? HighmarkLogo : WinLogo}
                            alt="Portal Logo"
                            className="logo brand-logo"
                        />
                    </a>
                </nav>
            </header>

            {/* Page Content */}
            <div className="registration-block-main patient-consent-screen">

                <div className="registration-form-main">
                    <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
                        <button onClick={handleBack} className="win-back-btn">
                            <span>
                                <i className="bi bi-chevron-left"></i>
                                Back
                            </span>
                        </button>
                    </div>
                    <div className="registration-form">
                        <div className="registration-process-form-wrapper mt-5">
                            <h3 className="page-heading-secondary-black-500 mt-4 mb-5">
                                How did you hear about <span className="page-heading-bold">WIN</span>?
                            </h3>

                            {serviceData?.length > 0 && (
                                serviceData.map((service, index) => (
                                    <div key={index} className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
                                        <input
                                            type="radio"
                                            className="form-check-input radio-btn win-form-check-input"
                                            id={`option-${index}`}
                                            name="referral"
                                            value={service.Serivce}
                                            checked={selected === service.Serivce}
                                            onChange={(e) => {
                                                setSelected(service.Serivce);
                                                setSelectedReferralAmount(service.Amount);
                                            }
                                            }
                                        />
                                        <label htmlFor={`option-${index}`} className="multistep-form-radio-checkbox-label">
                                            {service.Serivce}
                                        </label>
                                    </div>
                                ))
                            )}

                            {/* Next Button */}
                            <div className="mt-5">
                                <button onClick={onNextClick} className="win-btn-primary mobile-view">
                                    Next
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default Referral_Source;
